module.exports = __webpack_public_path__ + "static/media/Colette Straight Queen Headboard - 155 cm_Dark Blue.55ae57b5.png";